import { render, staticRenderFns } from "./autonymInfo.vue?vue&type=template&id=7b80295d&scoped=true&"
import script from "./autonymInfo.vue?vue&type=script&lang=js&"
export * from "./autonymInfo.vue?vue&type=script&lang=js&"
import style0 from "./autonymInfo.vue?vue&type=style&index=0&id=7b80295d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80295d",
  null
  
)

export default component.exports